import Axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import React, { Component } from "react";
import { CSVLink } from "react-csv";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import AlertModal from "../components/MainComponents/AlertMessagePopup";
import "../CSS/general.css";
import { API_ROUTE, LEGACY_SITE, Routes } from "../Helpers/Constants";
import AccountInfoModal from "./AccountInfoIframe";
import DownloadsModal from "./DownloadsModal";
import LitigationModal from "./LitigationModal";
import { Modal as Bootstrapodal } from "react-bootstrap";
import { Dropdown as BootstrapDropdown } from 'react-bootstrap';
import decryptParameter from "../Helpers/DeCryptParameter";
import { getItem } from "./IndexedDBUtils";
import AuthenticationContext from "../Store/Authentication-Context";
import { AppContext } from "../components/MainComponents/AppContext";
import DefaultProfile from "../images/DefaultProfile.png"
import AdditionLineControlModal from "./MainComponents/AdditionLineControlPopup";
import LoaderGif from "../images/365 loading.gif";
import CWInvoiceModal from "../components/Pages/CWInvoice";
import NotificationModal from "./NotificationModal";
import GuardianFileViewer from "../components/Pages/GuardianFileViewer";
export class NavBar extends Component {
    static displayName = NavBar.name;
    static contextType = AuthenticationContext;
    static contextType1 = AppContext;
    constructor(props) {
        super(props);
        const urlParams = new URLSearchParams(window.location.search);
        this.state = {
            orgId: urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId"),
            orgName: urlParams.get("orgName") ? urlParams.get("orgName") : sessionStorage.getItem("ManageOrgName"),
            tenantDomain: sessionStorage.getItem("ManageTenantDomain") ? sessionStorage.getItem("ManageTenantDomain") : "",
            impersonating: props.impersonating,
            page: props.page,
            isAdmin: false,
            isReseller: false,
            isDirectCustomer: false,
            inAdminGroup: false,
            fetchedData: false,
            licensedUsersCsv: "",
            restoreLogHtml: "",
            jobListCSV: "",
            showdropdown: false,
            showSupportAdmindropdown: false,
            showFinanceAdmindropdown: false,
            showAccountFunctiondropdown: false,
            showReportsdropdown: false,
            showSettingsdropdown: false,
            showreports: false,
            accountInfoUrl: "",
            IsLitigationHoldApplicable: false,
            orgStatus: [],
            accountInfoHeader: "",
            showAccountInfo: false,
            hideNavButtons: true,
            noClose:false,
            showPriceFeature: false,
            priceFeatureInfoUrl: "",
            priceFeatureHeader: "",
            showLitigationHold: false,
            showDownloads: false,
            showAddtionLines: false,
            showNotificationModal: false,
            showCWInvoice: false,
            showGuardianFileViewer: false,
            alertPop: false,
            alertMessage: [],
            priceModelTerm: "",
            photo: null,
            priceModelName: "",
            isRestoreDownloadRefreshed: false,
            isLitigationHoldRefreshed: false,
            isAzureGuardianOnly: props.isAzureGuardianOnly !== undefined ? props.isAzureGuardianOnly : true
        };
        this.CheckForLitigationHold(urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId"));
        this.getLicensedUsers = this.getLicensedUsers.bind(this);
        this.protectionReport = this.protectionReport.bind(this);
        this.jobListAudit = this.jobListAudit.bind(this);
        this.csvLinkRef = React.createRef();
        this.htmlLinkRL = React.createRef();
        this.getSettings = this.getSettings.bind(this);
        this.hideAccountInfoIframe = this.hideAccountInfoIframe.bind(this);
        this.cancelAlertClick = this.cancelAlertClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeCWInvoiceModal = this.closeCWInvoiceModal.bind(this);
        this.closeGuardianFileViewerModal = this.closeGuardianFileViewerModal.bind(this);
        this.getSettings();
        this.hideDownloads = this.hideDownloads.bind(this);
        this.hideLitigation = this.hideLitigation.bind(this)
    }

   

    componentDidMount() {
        window.addEventListener('message', this.handleMessage);
       
        this.loadPhoto();
    }
    toggleModal = () => {
        this.setState((prevState) => ({ showNotificationModal: !prevState.showNotificationModal }));
    };
    componentWillUnmount() {
        window.removeEventListener('message', this.handleMessage);
    }
    handleMessage = (event) => {

        const iframe = document.getElementById('AccountInfoId');
        if (event.source === iframe.contentWindow && event.data === 'changeUrl') {
            this.setState({
                showAccountInfo: false,
                priceFeatureHeader: "Packages",
                priceFeatureInfoUrl: "/PricingModel?orgId=" + this.state.orgId + "&orgName=" + this.state.orgName + "&resellerOnly=false&displayOnly=false&collapsed=false",
                showPriceFeature: true
            });
        }
    };

    async CheckForLitigationHold(orgName, orgId) {
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        }; var _orgId = orgId ? orgId : this.state.orgId;
        //Axios.get(API_ROUTE + Routes.CHECK_ENTRA_JOB + "/" + _orgName, config)
        //    .then((response) => {
        //        if (response.data !== "" && response.data !== "Failed") {
        //            this.setState({
        //                isEntraButtonEnabled: true
        //            });
        //        }
        //    })
        //    .catch((reason) => {
        //    });
        let ModelUserName = "NA";
        if (sessionStorage.UserName) {
            ModelUserName = sessionStorage.UserName;
        }
        Axios.get(API_ROUTE + Routes.PRICING_MODEL_ID + "/" + _orgId + "/" + ModelUserName, config)
            .then((response) => {
                if (response.data !== "" && response.data !== "Failed") {
                    let selectItems = JSON.parse(response.data);
                    const isLHoldTrue = !!(selectItems?.features?.find(feature => feature.featureType === "LHOLD")?.featureValue?.toLowerCase() === "true");

                    this.setState({
                        IsLitigationHoldApplicable: isLHoldTrue
                    });

                }
            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }

    async loadPhoto() {
        const photo = await getItem('Photo');
        if (photo && photo !== 'null') {
            this.setState({ photo });
        }
    }

    async getSettings() {
        if (!this.state.fetchedData) {
       
            const authContext = this.props.authContext || this.context;
            const { setAuthContext } = authContext;
            var tokenString = await setAuthContext(new Date());
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            await Axios.get(API_ROUTE + Routes.GET_NAVBAR_SETTINGS, config)
                .then((response) => {
                    let settings = response.data;
                    this.setState({
                        isAdmin: settings.isAdmin,
                        isReseller: settings.isReseller,
                        fetchedData: true,
                        inAdminGroup: settings.inAdminGroup,
                        isDirectCustomer: settings.isDirectCustomer,
                    });
                    if (settings.orgStatus.status === 'Failed') {

                        if (!settings.isAdmin && (this.state.page === "main" || this.state.page === "restore"))
                        {
                            this.setState({
                                orgStatus: response.data,
                                priceModelTerm: response.data.termValue,
                                accountInfoHeader: "Account Management",
                                accountInfoUrl: "/ContractCommit?signkey=" + this.state.orgId + "&reseller=" + settings.isReseller + "&directCustomer=" + settings.isDirectCustomer + "&status=Failed&userPrice=" + settings.orgStatus.userPrice + "&priceName=" + settings.tenantServiceData.price.name + "&quotaValue=" + settings.orgStatus.quotaValue + "&termValue=" + settings.orgStatus.termValue + "&isManaged=" + (this.state.orgId !== sessionStorage.getItem("orgId")),
                                showAccountInfo: true,
                                noClose: true,
                            });
                        }
                        else {
                            this.setState({
                                orgStatus: settings.orgStatus, priceModelTerm: settings.orgStatus.termValue,
                                noClose: false,
                                hideNavButtons: false,
                            });
                        }

                    }
                    else {
                        this.setState({
                            orgStatus: settings.orgStatus, priceModelTerm: settings.orgStatus.termValue,
                            noClose: false,
                            hideNavButtons: false,
                        });
                    }
                    this.setState({ orgStatus: settings.orgStatus, priceModelTerm: settings.orgStatus.termValue });
                    this.setState({
                        priceModelName: settings.tenantServiceData?.price?.name
                    });     
                })
                .catch((reason) => {
                    console.log("catch" + reason);
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });
        }

    }

    hideAccountInfoIframe() {
        this.setState({
            accountInfoUrl: "", 
            showAccountInfo: false
        });
    }
    hideDownloads() {
        this.setState({
            showDownloads: false,
            isRestoreDownloadRefreshed: false
        });
    }

    hideLitigation() {
        this.setState({
            showLitigationHold: false,
            isLitigationHoldRefreshed: false
        });
    }

    closeModal() {
     
        this.setState({
            showAddtionLines: false
        });
    }
    closeCWInvoiceModal() {

        this.setState({
            showCWInvoice: false
        });
    }
    closeGuardianFileViewerModal() {

        this.setState({
            showGuardianFileViewer: false
        });
    }
    cancelAlertClick() {
        this.setState({
            alertPop: false
        });
    }

    showHelpPages() {
        const url = this.state.page === "main" ? "https://cloudcover365.virtualdcs.co.uk/helpme/BackupManagement.html" : "https://cloudcover365.virtualdcs.co.uk/helpme/Introduction.html"
        window.open(url, '_blank');
    }
    async getLicensedUsers(e) {
        e.preventDefault();
        let toastId = toast("Licensed User list will be available in downloads section once ready", { autoClose: false });
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        if (this.state.tenantDomain !== "") {
            Axios.get(API_ROUTE + Routes.GET_LICENSED_USERS + "/" + this.state.orgId + "/" + this.state.tenantDomain, config)
                .then((response) => {
                    toast.dismiss(toastId);
                })
                .catch((reason) => {
                    toast.dismiss(toastId);
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });
        }
        else {
            toast.error("Unable To fetch Tenant domain");
        }
    }
  
    async runInvoiceProcess(e) {
        // e.preventDefault();
        const ToastContent = ({ message }) => (
            <div dangerouslySetInnerHTML={{ __html: message }} />
        );
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.get(API_ROUTE + Routes.RUN_INVOICE_PROCESS, config)
            .then((response) => {
                if (response.data.result) {
                    toast(<ToastContent message={response.data.result} />, { autoClose: false });
                   // toast.dismiss(toastId);
                }

            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }
    async CreateCWInvoices(e) {
        // e.preventDefault();
        const ToastContent = ({ message }) => (
            <div dangerouslySetInnerHTML={{ __html: message }} />
        );
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
            },
        };
        Axios.get(API_ROUTE + Routes.CREATE_CONNECTWISE_INVOICE, config)
            .then((response) => {

                if (response.data.result) {
                     toast(<ToastContent message={response.data.result} />, { autoClose: false });
                }

            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }
    
    async runInvoiceBatch(e) {
        // e.preventDefault();
        const ToastContent = ({ message }) => (
            <div dangerouslySetInnerHTML={{ __html: message }} />
        );
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.get(API_ROUTE + Routes.RUN_INVOICE_BATCH, config)
            .then((response) => {
                if (response.data.result) {
                    toast(<ToastContent message={response.data.result} />, { autoClose: false });
                }

            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
           });
    }

    async proxyTest(userName) {
        //e.preventDefault();
        const ToastContent = ({ message }) => (
            <div dangerouslySetInnerHTML={{ __html: message }} />
        );
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.post(API_ROUTE + Routes.PROXY_TEST, { userName: userName }, config)
            .then((response) => {

                if (response.data) {
                    toast(<ToastContent message={response.data} />, { autoClose: false });
                }

            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }
    async runBatch(userName) {
        //e.preventDefault();
        const ToastContent = ({ message }) => (
            <div dangerouslySetInnerHTML={{ __html: message }} />
        );
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.post(API_ROUTE + Routes.RUN_BATCH, { userName: userName }, config)
            .then((response) => {
                if (response.data) {
                    toast(<ToastContent message={response.data} />, { autoClose: false });
                   // toast.dismiss(toastId);
                }

            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }

    async protectionReport(e) {
        e.preventDefault();
        let toastId = toast("Protection Report will be available in downloads section once ready. This may take up to 15 minutes depending on the size of your organisation.", { autoClose: false });
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),

            },
            responseType: 'blob',
        };
        if (this.state.tenantDomain !== "") {
            Axios.get(API_ROUTE + Routes.GET_PROTECTION_REPORT + "/" + this.state.orgId + "/" + this.state.tenantDomain, config)
                .then((response) => {
                    ////var blob = new Blob([response.data], {
                    ////    type: "application/pdf",
                    ////});
                    toast.dismiss(toastId);

                })
                .catch((reason) => {
                    console.log("Protection report error");
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }

                });
        }
        else {
            toast.error("Unable To fetch Tenant domain")
        }
    }

    async restoreAudit(e) {
        e.preventDefault();
        //let toastId = toast("Downloading Restore Session Audit Report. This may take up to 15 minutes depending on the size of your organisation.", { autoClose: false });
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.get(API_ROUTE + Routes.GET_RESTORESESSION_REPORT + "/" + this.state.orgId, config)
            .then((response) => {

                let resp = response.data.replace('"', '');

                const parser = new DOMParser();
                const doc = parser.parseFromString(resp, "text/html");

                // Get number of columns from the table header
                const columnCount = doc.querySelectorAll("#table thead th").length;

                // Get the first row in the tbody
                const firstRow = doc.querySelector("#table tbody tr");
                const tdCells = firstRow?.querySelectorAll("td") || [];

                // Check if all td cells are "--" and count matches header
                const isDummyRow = (
                    tdCells.length === columnCount &&
                    [...tdCells].every(td => td.textContent.trim() === "--")
                );

                if (isDummyRow) {
                     toast("No restore operation has been performed in the organization.", { autoClose: 3000 });
                    //toast.dismiss(toastId);
                }

                else {
                    toast("Downloading Restore Session Audit Report. This may take up to 15 minutes depending on the size of your organisation.", { autoClose: 3000 });
                    //toast.dismiss(toastId);
                    resp = resp.replaceAll('"', ' ')

                    ////this.setState({ restoreLogHtml: resp }, () => {
                    ////    const blob = new Blob([this.state.restoreLogHtml], { type: 'text/html' });
                    ////    const url = URL.createObjectURL(blob);
                    ////    URL.revokeObjectURL(url);
                    ////});
                    const blob = new Blob([resp], { type: "text/html" });
                    const url = URL.createObjectURL(blob);

                    // Open HTML in a new tab
                    window.open(url, "_blank");

                    // Revoke after browser has loaded it
                    setTimeout(() => URL.revokeObjectURL(url), 1000);
                }
            })
            .catch((reason) => {
                let toastId = toast("Unable to Generated Report, Please contact support Team", { autoClose: false });
                toast.dismiss(toastId);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }
    
    async jobListAudit(e) {
        e.preventDefault();
        let toastId = toast("Downloading Jobs List Audit Report. This may take up to few minutes depending on the numbers of jobs available", { autoClose: false });
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        let payload = {
            type: "OrgJobList",
            orgs: [
                {
                    orgName: this.state.orgName,
                    orgId: this.state.orgId
                }
            ]
        };
        let object = null;
        if (this.state.page === "masterAdmin" || this.state.page === "eventlogs" || this.state.page === "jobmanagement" || this.state.page === "termsadmin" || this.state.page === "pricemanagement" || this.state.page === "knownErrors")
        {
            payload.type = "MasterAdminJobList";
            object = JSON.parse(decryptParameter(await getItem("ResellerOrgs")));
        }
        else if (this.state.page === "reseller")
        {
            payload.type = "ResellerJobList";
            object = JSON.parse(decryptParameter(await getItem("ResellerOrganisation")));
        }
  

        if (object) {
            payload.orgs = object.map(item => ({
                orgName: item.orgName,
                orgId: item.orgId
            }));
        }
        payload.orgId = this.state.orgId;

        await Axios.post(API_ROUTE + Routes.ALL_JOBS_STATUS, payload, config)
            .then((response) => {
                                    let csvData = response.data;
                                    toast.dismiss(toastId);
                                    this.setState({ jobListCSV: csvData }, () => {
                                        this.csvLinkRef.current.link.click();
                                    });
                                })
            .catch((reason) => {
                toast.dismiss(toastId);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
        
    }
        
    render() {
        const isVeeam365Engineer = sessionStorage.getItem("IsVeeam365Engineer") === "true";
        const isVeeam365JobManagement = sessionStorage.getItem("IsVeeam365JobManagement") === "true";
        const isVeeam365Restore = sessionStorage.getItem("IsVeeam365Restore") === "true";
        const isVeeam365EndUserRestore = sessionStorage.getItem("IsEndUser") === "true";
        const isVeeam365AdminSales = sessionStorage.getItem("IsVeeam365AdminSales") === "true";
        let helpModal = null;

        let navButtons = [];

        if ((this.state.isReseller && this.state.inAdminGroup && !isVeeam365JobManagement && !isVeeam365Restore) && this.state.page !== "settings") {
            // master on us reseller on reseller

            let orgsButton = (
                <li key="organisations" className="nav-item">
                    {this.state.page !== "masterAdmin" && this.state.page !== "reseller" ?
                        <a className="nav-link"
                            href={this.state.isAdmin ? "/masteradmin?orgId=" + sessionStorage.getItem("orgId") + "&orgName=" + sessionStorage.getItem("orgName") : "/reseller?orgId=" + sessionStorage.getItem("orgId") + "&orgName=" + sessionStorage.getItem("orgName")}//from whee it is called will query parameter be there
                            style={{ fontWeight: "normal" }}>
                            Organisations
                        </a> :
                        <span className="nav-link" style={{ fontWeight: this.state.page === "masterAdmin" || this.state.page === "reseller" ? "bold" : "normal" }}>
                            Organisations
                        </span>}
                </li>
            );
            navButtons.push(orgsButton);
        }

        if ((this.state.page !== "jobmanagement" && this.state.page !== "eventlogs" && this.state.page !== "bucket" && this.state.page !== "masterAdmin" && this.state.page !== "reseller" && this.state.page !== "termsadmin" && this.state.page !== "pricemanagement") && !isVeeam365Restore && !isVeeam365EndUserRestore ) {
            let adminButton = (
                <li key="admin" className="nav-item" defaultChecked={this.state.page === "main"}>
                    <a className="nav-link"
                        style={{ fontWeight: this.state.page === "main" ? "bold" : "normal" }}

                        href={"/main?orgId=" + this.state.orgId + "&orgName=" + this.state.orgName}>

                        Admin

                    </a>
                </li>
            );
            navButtons.push(adminButton);
        }

        if ((sessionStorage.getItem('IsVeeam365Admin') === "true" || isVeeam365Engineer || !isVeeam365AdminSales) && (this.state.page === "masterAdmin" || this.state.page === "eventlogs" || this.state.page === "jobmanagement" || this.state.page === "termsadmin" || this.state.page === "pricemanagement" || this.state.page === "knownErrors")) {


            let resellerid = decryptParameter((sessionStorage.getItem("ResellerID")));
            let isAdmin = decryptParameter((sessionStorage.getItem("IsAdmin")));
            let userName = decryptParameter((sessionStorage.getItem("UserName")));
           

            let supportAdmin = (
                <Dropdown
                    key="rootAdminFunction"
                    value="rootrootAdminFunctionOpen"
                    isOpen={this.state.showSupportAdmindropdown}
                    toggle={(e) => { this.setState(prevState => ({ showSupportAdmindropdown: !prevState.showSupportAdmindropdown })); }}
                    className="mr-2"
                >
                    <DropdownToggle caret style={{ maxWidth: "150px", fontWeight: this.state.page === "eventlogs" || this.state.page === "jobmanagement" || this.state.page === "termsadmin" || this.state.page === "pricemanagement" ? "bold" : "normal" }}>
                        Support Admin
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem style={{ fontWeight: this.state.page === "eventlogs" ? "bold" : "normal" } }
                            onClick={(e) => {
                                window.location.href = "/EventLogs?orgId=" + this.state.orgId + "&orgName=" + this.state.orgName;

                            }
                            }
                        >
                            Event View
                        </DropdownItem>
                        <DropdownItem onClick={this.toggleModal}>Notifications</DropdownItem>
                        <DropdownItem
                            onClick={(e) => {
                                window.location.href = LEGACY_SITE + "CloudConnectList.aspx?userName= " + userName + "&isAdmin=" + isAdmin + "&resellerID=" + resellerid;

                            }
                            }
                        >
                            Veeam Cloud Connect
                        </DropdownItem>
                        <DropdownItem
                            onClick={(e) => {

                                this.runBatch(userName);
                            }
                            }
                        >
                            Manually run batches
                        </DropdownItem>
                        
                        <DropdownItem
                            onClick={(e) => {

                                this.proxyTest();
                            }
                            }
                        >
                            Refresh Proxy List
                        </DropdownItem>

                        <DropdownItem style={{ fontWeight: this.state.page === "jobmanagement" ? "bold" : "normal" }}
                            onClick={(e) => {
                                window.location.href = "/JobManagement?orgId=" + this.state.orgId + "&orgName=" + this.state.orgName;
                            }
                            }
                        >
                            Job Monitoring
                        </DropdownItem>

                        <DropdownItem style={{ fontWeight: this.state.page === "termsadmin" ? "bold" : "normal" }}
                            onClick={(e) => {
                                window.location.href = "/TermsAdmin?orgId=" + this.state.orgId + "&orgName=" + this.state.orgName;

                            }
                            }
                        >
                            Contract Terms
                        </DropdownItem>                        
                        <DropdownItem style={{ fontWeight: this.state.page === "pricemanagement" ? "bold" : "normal" }}
                            onClick={(e) => {
                                window.location.href = "/PriceManagement?orgId=" + this.state.orgId + "&orgName=" + this.state.orgName;

                            }
                            }
                        >
                            Price List Management
                        </DropdownItem>
                        <DropdownItem style={{ fontWeight: this.state.page === "knownErrors" ? "bold" : "normal" }}
                            onClick={(e) => {
                                window.location.href = "/KnownErrors?orgId=" + this.state.orgId + "&orgName=" + this.state.orgName;
                            }}
                        >
                            Known Errors
                        </DropdownItem>
                        <DropdownItem style={{ fontWeight: this.state.page === "guardianFileViewer" ? "bold" : "normal" }}
                            onClick={(e) => {
                                // window.location.href = "/GuardianFileViewer?orgId=" + this.state.orgId + "&orgName=" + this.state.orgName;
                                this.setState({

                                    showGuardianFileViewer: true
                                });
                            }
                            }
                        >
                            Guardian File Viewer
                        </DropdownItem>  
                    </DropdownMenu>
                </Dropdown>
            );

            navButtons.push(supportAdmin);

            let financeAdmin = (
                <Dropdown
                    key="rootFinanceAdmin"
                    value="rootrootAdminFunctionOpen"
                    isOpen={this.state.showFinanceAdmindropdown}
                    toggle={(e) => { this.setState(prevState => ({ showFinanceAdmindropdown: !prevState.showFinanceAdmindropdown })); }}
                    className="mr-2"
                >
                    <DropdownToggle caret style={{ maxWidth: "150px", fontWeight: "normal" }}>
                        Finance Admin
                    </DropdownToggle>
                    <DropdownMenu>
                       
                        <DropdownItem
                            onClick={(e) => {

                                this.CreateCWInvoices();
                            }
                            }
                        >
                            Create CW-Invoice
                        </DropdownItem>
                        <DropdownItem
                            onClick={(e) => {
                                this.setState({

                                    showAddtionLines: true
                                });
                            }
                            }
                        >
                            CW Sync
                        </DropdownItem>
                       
                                <DropdownItem onClick={(e) => {
                                    this.setState({

                                        showCWInvoice: true
                                    });
                                }
                                }>
                                    CW Direct Debit
                                </DropdownItem>
                           
                    </DropdownMenu>
                </Dropdown>
            );

            navButtons.push(financeAdmin);

        }


        if (
            !isVeeam365JobManagement && ((this.state.inAdminGroup || isVeeam365Engineer || isVeeam365Restore || isVeeam365EndUserRestore) && (this.state.page === "main" || this.state.page === "restore" ||  this.state.page === "peoplehrtoxero" || this.state.page === "settings" || this.state.page === "errorSuppression" || this.state.page === "manageSuppressions" ))
        ) {
            let restoreButton = (
                <li key="restore" className="nav-item">
                    <a className="nav-link"
                        style={{ fontWeight: this.state.page === "restore" ? "bold" : "normal" }}
                        href={"/Restore?orgId=" + this.state.orgId + "&orgName=" + this.state.orgName}>
                        Restore
                    </a>
                </li>
            );
            navButtons.push(restoreButton);
        }
        
        if (this.state.page !== "restore" && this.state.page !== "masterAdmin" && (this.state.isDirectCustomer || this.state.page === "reseller")) {

            let resellerid = decryptParameter((sessionStorage.getItem("ResellerID")));
            let packageDropdownItem = null;
                packageDropdownItem = (<DropdownItem
                    onClick={(e) => {
                        this.setState({
                            priceFeatureHeader: "Packages",
                            priceFeatureInfoUrl: "/PricingModel?orgId=" + this.state.orgId + "&orgName=" + this.state.orgName + "&resellerOnly=false&displayOnly=false&collapsed=false",
                            showPriceFeature: true
                        });
                    }
                    }
                >
                    Packages
                </DropdownItem >);
            let isMasterAdmin = (this.state.orgId === sessionStorage.getItem("orgId") && sessionStorage.getItem("ResellerID") === "1");
     
            let accountButton = (
                <Dropdown
                    key="root"
                    value="rootRestoreOpen"
                    isOpen={this.state.showdropdown}
                    toggle={(e) => { this.setState(prevState => ({ showdropdown: !prevState.showdropdown })); }}
                    className="mr-2"
                >
                    <DropdownToggle caret style={{ maxWidth: "150px" }}>
                        Account Info
                    </DropdownToggle>
                    <DropdownMenu>
                        
                        <DropdownItem
                            onClick={(e) => {
                                this.setState({
                                    accountInfoHeader: "Account Management",
                                    accountInfoUrl: "/ContractCommit?signkey=" + this.state.orgId + "&reseller=" + this.state.isReseller + "&directCustomer=" + this.state.isDirectCustomer + "&status=" + this.state.orgStatus.status + "&userPrice=" + this.state.orgStatus.userPrice + "&priceName=" + this.state.priceModelName + "&quotaValue=" + this.state.orgStatus.quotaValue + "&termValue=" + this.state.priceModelTerm + "&isManaged=" + (this.state.orgId !== sessionStorage.getItem("orgId")),
                                    showAccountInfo: true
                                });
                                console.log(this.state.accountInfoUrl);
                            }
                            }
                        >
                            Direct Debit
                        </DropdownItem>

                        {packageDropdownItem}
                    </DropdownMenu>
                </Dropdown>
            );
           
            if (!this.props.isAzureGuardianOnly && ((this.state.page === "settings" && resellerid === "1") || (this.state.page !== "settings"))) {
                navButtons.push(accountButton);
            }
        }

        if (!this.props.isAzureGuardianOnly && (this.state.page === "reseller" ||
            this.state.page === "masterAdmin" || this.state.page === "jobmanagement" || this.state.page === "termsadmin" || this.state.page === "pricemanagement" || this.state.page === "knownErrors" ||this.state.page === "eventlogs" ||
            this.state.page === "errorSuppression" || this.state.page === "manageSuppressions" ||
            (!isVeeam365JobManagement && (this.state.page === "main") ))) {
            let reportsDropdownButton = (
                <Dropdown
                    key="reports"
                    value="rootReportOpen"
                    isOpen={this.state.showReportsdropdown}
                    toggle={(e) => { this.setState(prevState => ({ showReportsdropdown: !prevState.showReportsdropdown })); }}
                    className="mr-2"
                >
                    <DropdownToggle caret style={{ maxWidth: "150px"}}>
                        Reports
                    </DropdownToggle>
                    <DropdownMenu>
                        {this.state.page === "main" ? 
                        <>
                            <DropdownItem onClick={this.protectionReport}>
                                Protection Report
                            </DropdownItem>
                            <DropdownItem onClick={this.getLicensedUsers}>
                                Licenced Users
                            </DropdownItem>
                            <DropdownItem
                                onClick={(e) => {
                                    this.restoreAudit(e)
                                    }
                                }
                            >
                                Restore Log

                                </DropdownItem>
                                <DropdownItem style={{ fontWeight: this.state.page === "tenantsummary" ? "bold" : "normal" }}
                                    onClick={(e) => {
                                        window.location.href = "/TenantSummary?orgId=" + this.state.orgId + "&orgName=" + this.state.orgName;

                                    }
                                    }
                                >
                                    Tenant Summary
                                </DropdownItem>
                               
                            </> : null}
                        {this.state.page === "reseller" ||
                            this.state.page === "masterAdmin" || this.state.page === "jobmanagement" || this.state.page === "termsadmin" || this.state.page === "pricemanagement" || this.state.page === "eventlogs" ?
                            <>
                                <DropdownItem
                                    onClick={(e) => {
                                        this.jobListAudit(e)
                                    }
                                    }
                                >

                                    JobList Log

                                </DropdownItem>

                            </> : null}


                    </DropdownMenu>
                </Dropdown >

            );
            navButtons.push(reportsDropdownButton);
        }

        if (!isVeeam365JobManagement && ( this.state.page === "restore" || this.state.page === "peoplehrtoxero" || this.state.page === "main" )) {
            let downloadButton = (
                <li key="download" className="nav-item d-flex">
                    <button className="nav-link a-icon"
                        style={{ fontWeight: "normal" }}
                        onClick={(e) => {
                            this.setState({
                                showDownloads: true,
                                isRestoreDownloadRefreshed: true
                            });
                        }} >
                        Downloads
                    </button>
                </li>
            );
            navButtons.push(downloadButton);
        }

        if (this.state.page === "restore" && this.state.IsLitigationHoldApplicable.toString() ==='true') {
            let litigationHoldButton = (
                <li key="litigationHold" className="nav-item d-flex">
                    <button className="nav-link a-icon"
                        style={{ fontWeight: "normal" }}
                        onClick={(e) => {
                            this.setState({
                                showLitigationHold: true,
                                isLitigationHoldRefreshed: true,
                            });
                        }} >
                        Litigation Hold
                    </button>
                </li>
            );
            navButtons.push(litigationHoldButton);
        }

        // Settings and Error Suppression (Task 9) are consolidated into one "Settings" dropdown
        // to keep the navbar compact. Each item keeps its original visibility rule:
        //   - General: same as the old standalone Settings button — excludes Engineers, Job
        //     Management and Restore.
        //   - Error Suppression: same as the old standalone button — excludes only Restore, per
        //     the client's round-2 replies (2026-08-17): Administrators (incl. Veeam365
        //     Engineers) yes; Job Management yes, read-only (need to see "Success with
        //     Suppressions", A4); Restore users no. Manage Suppressions is reached from within
        //     the Error Suppression page itself, so it no longer needs its own navbar entry.
        //   What a permitted user may DO is decided by the access level the API reports, which
        //   hides every mutating button — see SuppressionColumns' canChange.
        const canGeneralSettings = !isVeeam365Engineer && !isVeeam365JobManagement && !isVeeam365Restore;
        const canErrorSuppression = !isVeeam365Restore;
        const isOnSettingsPage = this.state.page === "settings" || this.state.page === "errorSuppression" || this.state.page === "manageSuppressions";
        if (!this.props.isAzureGuardianOnly && (this.state.page === "main" || isOnSettingsPage) && (canGeneralSettings || canErrorSuppression)) {
            let settingButton = (
                <Dropdown
                    key="settings"
                    value="rootSettingsOpen"
                    isOpen={this.state.showSettingsdropdown}
                    toggle={(e) => { this.setState(prevState => ({ showSettingsdropdown: !prevState.showSettingsdropdown })); }}
                    className="mr-2"
                >
                    <DropdownToggle caret style={{ fontWeight: isOnSettingsPage ? "bold" : "normal" }}>
                        Settings
                    </DropdownToggle>
                    <DropdownMenu>
                        {canGeneralSettings &&
                            <DropdownItem style={{ fontWeight: this.state.page === "settings" ? "bold" : "normal" }}
                                onClick={(e) => {
                                    window.location.href = "/settings?orgId=" + this.state.orgId + "&orgName=" + this.state.orgName;
                                }}>
                                General
                            </DropdownItem>
                        }
                        {canErrorSuppression &&
                            <DropdownItem style={{ fontWeight: this.state.page === "errorSuppression" ? "bold" : "normal" }}
                                onClick={(e) => {
                                    window.location.href = "/ErrorSuppression?orgId=" + this.state.orgId + "&orgName=" + this.state.orgName;
                                }}>
                                Error Suppression
                            </DropdownItem>
                        }
                    </DropdownMenu>
                </Dropdown>
            );
            navButtons.push(settingButton);
        }

        if (!this.props.isAzureGuardianOnly) {
            let helpButton = (
                <li key="help" className="nav-item d-flex">
                    <button className="nav-link a-icon"  onClick={() => {
                        this.showHelpPages();
                    }}>
                        Help
                    </button>
                </li>
            );
            navButtons.push(helpButton);
        }
        
        

        if (!this.state.fetchedData || this.state.hideNavButtons) {
            navButtons = [];
        }

        return (
            <React.Fragment>
                {helpModal}
                <nav className="navbar navbar-expand-lg navbar-light custStyle MenuFont titlebar">
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <div className="navbar-brand">
                            <div className="menulogo align-top  m-0 ms-2 mb-1 mt-1" alt="" ></div>
                        </div>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav mr-auto">
                                {navButtons}
                            </ul>

                            <div style={{ position: 'absolute', right: '15px', display: 'flex', alignItems: 'center' }} className="d-none d-xxl-flex">
                                <div style={{ display: 'flex', flexDirection: 'column', marginRight: '10px' }}>
                                    <div style={{ fontSize: "15px", color: "grey" }} className="userInfo">{sessionStorage.getItem('UserDisplayName')}</div>
                                    <div style={{ fontSize: "15px", color: "grey" }} className="userInfo">{sessionStorage.getItem('UserEmailID')}</div>
                                </div>
                                <BootstrapDropdown
                                    key="userAccountFunction"
                                    value="useruserAccountFunctionOpen"
                                    isOpen={this.state.showAccountFunctiondropdown}
                                    toggle={(e) => { this.setState(prevState => ({ showAccountFunctiondropdown: !prevState.showAccountFunctiondropdown })); }}
                                    className="mr-2"
                                >
                                    <BootstrapDropdown.Toggle id="user-dropdown" className="p-0">
                                        <div>
                                            {this.state.photo && this.state.photo !== 'null' ? (
                                                <div style={{ borderRadius: '50%', overflow: 'hidden', border: '2px solid #fff' }}>
                                                    <img src={`data:image/png;base64,${this.state.photo }`} alt="User profile" style={{ width: '45px', height: '45px', objectFit: 'cover' }} />
                                                </div>
                                            ) : this.state.photo === 'null' ? (
                                                <div style={{ borderRadius: '50%', overflow: 'hidden', border: '2px solid #fff' }}>
                                                    <img src={DefaultProfile} style={{ width: '45px', height: '45px', objectFit: 'cover' }} alt="User profile" />
                                                </div>
                                            ) : (
                                                <div style={{ borderRadius: '50%', overflow: 'hidden', border: '2px solid #fff' }}>
                                                    <img src={DefaultProfile} style={{ width: '45px', height: '45px', objectFit: 'cover' }} alt="User profile" />
                                                </div>
                                            )}
                                        </div>
                                    </BootstrapDropdown.Toggle>
                                    <BootstrapDropdown.Menu >
                                        <BootstrapDropdown.Item href="#" onClick={(e) => { window.location.href = "/Logout"; }}>Log out</BootstrapDropdown.Item>
                                    </BootstrapDropdown.Menu>
                                </BootstrapDropdown>

                            </div>
                            <div style={{ position: 'absolute', right: '15px', display: 'flex', alignItems: 'center' }} className="d-xxl-none">
                                <BootstrapDropdown
                                    key="userAccountFunction"
                                    value="useruserAccountFunctionOpen"
                                    isOpen={this.state.showAccountFunctiondropdown}
                                    toggle={(e) => { this.setState(prevState => ({ showAccountFunctiondropdown: !prevState.showAccountFunctiondropdown })); }}
                                >
                                    <BootstrapDropdown.Toggle id="user-dropdown" className="p-0">
                                        <div style={{ backgroundColor: "white" }}>
                                            {this.state.photo && this.state.photo !== 'null' ? (
                                                <div style={{ borderRadius: '50%', overflow: 'hidden', border: '2px solid #fff' }}>
                                                    <img src={`data:image/png;base64,${this.state.photo}`} alt="User profile" style={{ width: '45px', height: '45px', objectFit: 'cover' }} />
                                                </div>
                                            ) : this.state.photo  === 'null' ? (
                                                <div style={{ borderRadius: '50%', overflow: 'hidden', border: '2px solid #fff' }}>
                                                    <img src={DefaultProfile} style={{ width: '45px', height: '45px', objectFit: 'cover' }} alt="User profile" />
                                                </div>
                                            ) : (
                                                <div style={{ borderRadius: '50%', overflow: 'hidden', border: '2px solid #fff' }}>
                                                    <img src={DefaultProfile} style={{ width: '45px', height: '45px', objectFit: 'cover' }} alt="User profile"  />
                                                </div>
                                            )}
                                        </div>
                                    </BootstrapDropdown.Toggle>

                                    <BootstrapDropdown.Menu>
                                        <BootstrapDropdown.Item href="#" onClick={(e) => { e.preventDefault(); }}>{sessionStorage.getItem('UserDisplayName')}</BootstrapDropdown.Item>
                                        <BootstrapDropdown.Item href="#" onClick={(e) => { e.preventDefault(); }}>{sessionStorage.getItem('UserEmailID')}</BootstrapDropdown.Item>
                                        <BootstrapDropdown.Divider />
                                        <BootstrapDropdown.Item href="#" onClick={(e) => { window.location.href = "/Logout"; }}>Log out</BootstrapDropdown.Item>
                                    </BootstrapDropdown.Menu>
                                </BootstrapDropdown>
                            </div>
                        </div>
                    </div>
                    <ToastContainer limit={4} style={{ fontSize: "small" }} />
                    <CSVLink className="nav-link" filename="RestoreLog.html" data={this.state.restoreLogHtml} ref={this.htmlLinkRL}></CSVLink>
                    <CSVLink className="nav-link" filename="JobsList.csv" data={this.state.jobListCSV} ref={this.csvLinkRef}></CSVLink>
                    <AccountInfoModal displayModal={this.state.showAccountInfo} noClose={((this.state.isReseller && this.state.orgId === sessionStorage.getItem("orgId") )&& this.state.page !== "reseller" && !this.state.isAdmin && this.state.orgStatus.status === "Failed") || this.state.noClose} closeModal={this.hideAccountInfoIframe} action={this.state.accountInfoHeader} url={this.state.accountInfoUrl} />
                    <Bootstrapodal
                        size="xl"
                        show={this.state.showPriceFeature}
                        onHide={(e) => {
                            window.location.reload();
                            this.setState({
                                showPriceFeature: false
                            });
                        }}
                        backdrop="static"
                        aria-labelledby="main-popup"
                        centered
                        className="PriceFeature-modal"
                        style={{ marginTop: 'auto' }}
                    >
                        <Bootstrapodal.Header closeButton>
                            <Bootstrapodal.Title id="main-popup">
                                {this.state.priceFeatureHeader}
                            </Bootstrapodal.Title>
                        </Bootstrapodal.Header>
                        <Bootstrapodal.Body className="p-0">

                            {this.state.showPriceFeature ? <iframe id="AccountPriceFeatureId" sandbox="allow-scripts allow-same-origin"
                                src={this.state.priceFeatureInfoUrl}
                                title="AccountPriceFeature"
                                style={{ height: "82vh", width: '100%', minWidth: "-webkit-fill-available", borderBottomLeftRadius: '15px', borderBottomRightRadius:'15px' }}
                            >  </iframe> :
                                <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '35vh' }}>
                                    <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                                </div>}
                        </Bootstrapodal.Body>
                    </Bootstrapodal>

                    <DownloadsModal displayModal={this.state.showDownloads} closeModal={this.hideDownloads} orgId={this.state.orgId} refresh={this.state.isRestoreDownloadRefreshed} />
                    <LitigationModal displayModal={this.state.showLitigationHold} closeModal={this.hideLitigation} orgId={this.state.orgId} refresh={this.state.isLitigationHoldRefreshed} />
                    {this.state.showAddtionLines === true &&
                        <AdditionLineControlModal displayModal={this.state.showAddtionLines} closeModal={this.closeModal} />}
                    {this.state.showCWInvoice.toString() === 'true' && 
                        <CWInvoiceModal displayModal={this.state.showCWInvoice} closeCWInvoiceModal={this.closeCWInvoiceModal} />}
                    {this.state.showGuardianFileViewer.toString() === 'true' &&
                        <GuardianFileViewer displayModal={this.state.showGuardianFileViewer} closeGuardianFileViewerModal={this.closeGuardianFileViewerModal} />}
                    <AlertModal displayModal={this.state.alertPop} closeModal={this.cancelAlertClick} message={this.state.alertMessage} />
                    <NotificationModal isOpen={this.state.showNotificationModal} toggle={this.toggleModal} />
                </nav>
            </React.Fragment>
        );
    }
}
